<template>
    <div>
        <b-row>
            <b-col cols="12" md="6" lg="6">
                <b-form-group :label="$t('academic_year')">
                    <div class="label-as-input">{{ isNotNullValue(formData.academic_year) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <b-form-group :label="$t('price')">
                    <div class="label-as-input">{{ isNotNullValue(formData.price) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <b-form-group :label="$t('currency')">
                    <div class="label-as-input">{{ isNotNullValue(formData.currency) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <b-form-group :label="$t('number_of_installments')">
                    <div class="label-as-input">{{ isNotNullValue(formData.number_of_installments) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <b-form-group :label="$t('due_date')">
                    <div class="label-as-input">{{ formattedDueDates }}</div>
                </b-form-group>
            </b-col>
        </b-row>

    </div>
</template>

<script>
// Services
import PilotagePriceService from '@/services/PilotagePriceService';

export default {
    props: {
        formId: {
            type: String
        }
    },
    data() {
        return {
            formData: {},
            formLoading: false
        }
    },
    async created() {
        await this.get(this.formId)
    },
    computed: {
        formattedDueDates() {
            if (!Array.isArray(this.formData.due_dates) || !this.formData.due_dates.length) {
                return '-';
            }

            return this.formData.due_dates.join(', ');
        }
    },
    methods: {
        get(id) {
            PilotagePriceService.get(id)
                .then(response => {
                    this.formData = response.data.data;
                })
                .catch(e => {
                    this.showErrors(e)
                })
        }

    }
}
</script>
